import React from "react";
import { CopilotKit } from "@copilotkit/react-core";
import { getCookie } from "@services/getSetCookie";

import ChatBot from "@components/ChatBot";

export default function Chatbot(props: {
	isOpenChatBot: boolean;
	handleChatBotToggle: () => void;
}): JSX.Element | null {
	const csrfToken = getCookie("_csrf");
	return (
		<CopilotKit
			runtimeUrl={`${process.env.BACKEND_URI}/api/v2/assistai`}
			agent="pc_agent"
			showDevConsole={false}
			credentials="include"
			headers={{
				"X-CSRF-Token": csrfToken as string,
			}}
		>
			{props.isOpenChatBot && (
				<div
					className="pc-chatBot-overlay"
					style={{
						height: window.innerHeight,
					}}
				>
					<ChatBot handleChatBotToggle={props.handleChatBotToggle} />
				</div>
			)}
		</CopilotKit>
	);
}
